import * as Sentry from "@sentry/react";
import * as React from 'react';
import {
  Routes,
  Route,
  NavLink,
  Navigate,
  useNavigate,
  useLocation,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LoginPage from './login.jsx'
import AdminPage from './indexAdmin.jsx'
import SuperAdminPage from './indexSuperAdmin.jsx'

const fakeAuth = () =>
  new Promise((resolve) => {
    setTimeout(() => resolve('2342f2f1d131rf12'), 250);
  });

const AuthContext = React.createContext(null);

const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [token, setToken] = React.useState(null);

  const handleLogin = async () => {
    const token = await fakeAuth();

    setToken(token);

    const origin = location.state?.from?.pathname || '/dashboard';
    navigate(origin);
  };

  const handleLogout = () => {
    setToken(null);
  };

  const value = {
    token,
    onLogin: handleLogin,
    onLogout: handleLogout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  return React.useContext(AuthContext);
};

const ProtectedRoute = ({ children }) => {
  const { token,isAuthenticated } = useAuth();
  const location = useLocation();

  if (isAuthenticated) {
    return <Navigate to="/home" replace state={{ from: location }} />;
  }

  return children;
};

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const App = (props) => {
  let navigate = useNavigate();

  return (
    <AuthProvider>
      {/* <button onClick={() => { throw new Error("Sentry Test Error"); }}>Test Sentry</button> */}
      <SentryRoutes>
        <Route 
          index 
          element={
            <LoginPage onLogin={() => navigate('/adminpage/home')} onSuperLogin={() => navigate('/superadminpage/home')} />
          } 
        />
        <Route 
          path="login"
          index 
          element={
            <LoginPage onLogin={() => navigate('/adminpage/home')} onSuperLogin={() => navigate('/superadminpage/home')}/>
          } 
        />
        <Route path="cool" element={<Cool/>} />
        <Route path="cli" element={<Navigate replace to="/adminpage/cli" />} />
        <Route path="cli-install" element={<Navigate replace to="/adminpage/cli-install" />} />
        <Route path="cli-auth" element={<Navigate replace to="/adminpage/cli-auth" />} />
        <Route
          path="adminpage/*"
          element={
            <ProtectedRoute loggedIn={props.isAuthenticated}>
              <AdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="superadminpage/*"
          element={
            <ProtectedRoute loggedIn={props.isAuthenticated}>
              <SuperAdminPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/logout/disconnect"
          element={
              <Navigate replace to="/login" />
          }
        />
        <Route path="*" element={<NoMatch />} />
      </SentryRoutes>
    </AuthProvider>
  );
};


const SuperAdminPageOLD = () => {
  return (
    <>
      <h2>Admin (Protected)</h2>
    </>
  );
};

const Cool = () => {
  return <p>It is Cool</p>;
};
const NoMatch = () => {
  return <p>There's nothing here: 404!</p>;
};

function mapStateToProps(state){
  return {
    isAuthenticated: state.auth.isAuthenticated,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
